import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Media from 'react-media';
import { supportedMedia } from '../../../styles/media';
import * as LayoutActions from '../layout.actions';

class TestComponent extends Component {
  static propTypes = {
    breakpoint: PropTypes.string,
    breakpointChange: PropTypes.func.isRequired,
    matches: PropTypes.string,
  };

  componentDidMount = () => {
    const { breakpoint, breakpointChange, matches } = this.props;
    if (matches !== breakpoint) {
      breakpointChange(matches);
    }
  };

  render() {
    return null;
  }
}

const mapStateToProps = state => {
  const { breakpoint } = state.layout;

  return {
    breakpoint,
  };
};

const ConnectedTestComponent = connect(mapStateToProps, LayoutActions)(
  TestComponent
);

const BreakpointSniffer = props => {
  const primary = supportedMedia[0];
  return (
    <Media query={primary.query}>
      {matches =>
        matches ? (
          <ConnectedTestComponent matches={primary.key} />
        ) : (
          <React.Fragment>
            <Media query={{minWidth:481, maxWidth: 1024}} render={() => <ConnectedTestComponent matches="tablet" />} />
            <Media query={{maxWidth:480}} render={() => <ConnectedTestComponent matches="phone" />} />
          </React.Fragment>
        )
      }
    </Media>
  );
};

export default BreakpointSniffer;



// WEBPACK FOOTER //
// ./src/modules/layout/components/BreakpointSniffer.js